import { React, useEffect } from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="container">
      <div className="not-found">
        <div className="hero">
          <div className="error-code-hero">
            <h1>4</h1>
            <div className="blob">
              <svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <radialGradient id="gradient">
                    <stop offset="0%" stopColor="#f3087f"></stop>
                    <stop offset="100%" stopColor="#da325c"></stop>
                  </radialGradient>
                  <clipPath id="a">
                    <path fill="url(#gradient)" filter="url(#filter)">
                      <animate
                        attributeName="d"
                        dur="10000ms"
                        repeatCount="indefinite"
                        values="M474.5,290.5Q473,331,450.5,365Q428,399,396.5,424.5Q365,450,328,467.5Q291,485,249.5,486.5Q208,488,166.5,477Q125,466,94,436.5Q63,407,46.5,368.5Q30,330,19.5,290Q9,250,21.5,210.5Q34,171,52.5,135.5Q71,100,103,75Q135,50,171.5,31Q208,12,250.5,9.5Q293,7,330,27Q367,47,400.5,71.5Q434,96,454,132.5Q474,169,475,209.5Q476,250,474.5,290.5Z;
M484,289.5Q468,329,448.5,364.5Q429,400,398,426Q367,452,329.5,469.5Q292,487,251,482.5Q210,478,171.5,465.5Q133,453,98,430Q63,407,45,369Q27,331,19.5,290.5Q12,250,22.5,210.5Q33,171,51,134.5Q69,98,102,74Q135,50,172,33.5Q209,17,250,16Q291,15,332.5,25.5Q374,36,407.5,63Q441,90,461,128Q481,166,490.5,208Q500,250,484,289.5Z;
M479.5,291Q474,332,454.5,368.5Q435,405,400,427Q365,449,327,460.5Q289,472,248,483.5Q207,495,170.5,473Q134,451,96.5,431Q59,411,42,371.5Q25,332,23.5,291Q22,250,19,207.5Q16,165,39.5,129Q63,93,99.5,73Q136,53,172.5,34.5Q209,16,250,16Q291,16,327.5,34.5Q364,53,402,72Q440,91,458.5,129Q477,167,481,208.5Q485,250,479.5,291Z;
M477.5,290Q469,330,452.5,368Q436,406,401,428.5Q366,451,327.5,462Q289,473,249,478.5Q209,484,171,468Q133,452,100,428Q67,404,43.5,369Q20,334,21.5,292Q23,250,23,208.5Q23,167,48.5,134.5Q74,102,99.5,68Q125,34,166,20.5Q207,7,248,17Q289,27,328.5,36.5Q368,46,398,73.5Q428,101,454,133.5Q480,166,483,208Q486,250,477.5,290Z;
M474.5,290.5Q473,331,450.5,365Q428,399,396.5,424.5Q365,450,328,467.5Q291,485,249.5,486.5Q208,488,166.5,477Q125,466,94,436.5Q63,407,46.5,368.5Q30,330,19.5,290Q9,250,21.5,210.5Q34,171,52.5,135.5Q71,100,103,75Q135,50,171.5,31Q208,12,250.5,9.5Q293,7,330,27Q367,47,400.5,71.5Q434,96,454,132.5Q474,169,475,209.5Q476,250,474.5,290.5Z"
                      ></animate>
                    </path>
                  </clipPath>
                  <filter
                    id="filter"
                    x="0"
                    y="0"
                    width="100%"
                    height="100%"
                    filterUnits="objectBoundingBox"
                    primitiveUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                  >
                    <feTurbulence
                      type="fractalNoise"
                      baseFrequency="0.005 0.003"
                      numOctaves="2"
                      seed="2"
                      stitchTiles="stitch"
                      x="0%"
                      y="0%"
                      width="100%"
                      height="100%"
                      result="turbulence"
                    ></feTurbulence>
                    <feGaussianBlur
                      stdDeviation="20 0"
                      x="0%"
                      y="0%"
                      width="100%"
                      height="100%"
                      in="turbulence"
                      edgeMode="duplicate"
                      result="blur"
                    ></feGaussianBlur>
                    <feBlend
                      mode="color-dodge"
                      x="0%"
                      y="0%"
                      width="100%"
                      height="100%"
                      in="SourceGraphic"
                      in2="blur"
                      result="blend"
                    ></feBlend>
                    
                  </filter>
                  <filter
                    id="blur"
                    width="160%"
                    height="160%"
                    x="-30%"
                    y="-30%"
                  >
                    <feFlood floodColor="#000" result="neutral" />
                    <feGaussianBlur
                      in="SourceGraphic"
                      stdDeviation="30"
                      result="blurred"
                    />
                    <feMerge>
                      <feMergeNode in="neutral" />
                      <feMergeNode in="blurred" />
                    </feMerge>
                  </filter>

                 
                </defs>
                <g clipPath="url(#a)" filter="url(#blur)">
                  <path fill="url(#gradient)" filter="url(#filter)">
                    <animate
                      attributeName="d"
                      dur="10000ms"
                      repeatCount="indefinite"
                      values="M474.5,290.5Q473,331,450.5,365Q428,399,396.5,424.5Q365,450,328,467.5Q291,485,249.5,486.5Q208,488,166.5,477Q125,466,94,436.5Q63,407,46.5,368.5Q30,330,19.5,290Q9,250,21.5,210.5Q34,171,52.5,135.5Q71,100,103,75Q135,50,171.5,31Q208,12,250.5,9.5Q293,7,330,27Q367,47,400.5,71.5Q434,96,454,132.5Q474,169,475,209.5Q476,250,474.5,290.5Z;
M484,289.5Q468,329,448.5,364.5Q429,400,398,426Q367,452,329.5,469.5Q292,487,251,482.5Q210,478,171.5,465.5Q133,453,98,430Q63,407,45,369Q27,331,19.5,290.5Q12,250,22.5,210.5Q33,171,51,134.5Q69,98,102,74Q135,50,172,33.5Q209,17,250,16Q291,15,332.5,25.5Q374,36,407.5,63Q441,90,461,128Q481,166,490.5,208Q500,250,484,289.5Z;
M479.5,291Q474,332,454.5,368.5Q435,405,400,427Q365,449,327,460.5Q289,472,248,483.5Q207,495,170.5,473Q134,451,96.5,431Q59,411,42,371.5Q25,332,23.5,291Q22,250,19,207.5Q16,165,39.5,129Q63,93,99.5,73Q136,53,172.5,34.5Q209,16,250,16Q291,16,327.5,34.5Q364,53,402,72Q440,91,458.5,129Q477,167,481,208.5Q485,250,479.5,291Z;
M477.5,290Q469,330,452.5,368Q436,406,401,428.5Q366,451,327.5,462Q289,473,249,478.5Q209,484,171,468Q133,452,100,428Q67,404,43.5,369Q20,334,21.5,292Q23,250,23,208.5Q23,167,48.5,134.5Q74,102,99.5,68Q125,34,166,20.5Q207,7,248,17Q289,27,328.5,36.5Q368,46,398,73.5Q428,101,454,133.5Q480,166,483,208Q486,250,477.5,290Z;
M474.5,290.5Q473,331,450.5,365Q428,399,396.5,424.5Q365,450,328,467.5Q291,485,249.5,486.5Q208,488,166.5,477Q125,466,94,436.5Q63,407,46.5,368.5Q30,330,19.5,290Q9,250,21.5,210.5Q34,171,52.5,135.5Q71,100,103,75Q135,50,171.5,31Q208,12,250.5,9.5Q293,7,330,27Q367,47,400.5,71.5Q434,96,454,132.5Q474,169,475,209.5Q476,250,474.5,290.5Z"
                    ></animate>
                  </path>
                </g>
              </svg>
            </div>
            <h1>4</h1>
          </div>
          <h3 className="hero-title">
            Looks like we are missing some page, or you typed something wrong in
            the URL, heres a way to get back
          </h3>
          <Link className="link-btn" to="/service">
            <div className="button ">
              <p>Explore our services</p>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M18.3828 10.8828C18.8711 10.3945 18.8711 9.60156 18.3828 9.11328L12.1328 2.86328C11.6445 2.375 10.8516 2.375 10.3633 2.86328C9.875 3.35156 9.875 4.14453 10.3633 4.63281L15.7305 10L10.3672 15.3672C9.87891 15.8555 9.87891 16.6484 10.3672 17.1367C10.8555 17.625 11.6484 17.625 12.1367 17.1367L18.3867 10.8867L18.3828 10.8828ZM4.63281 17.1328L10.8828 10.8828C11.3711 10.3945 11.3711 9.60156 10.8828 9.11328L4.63281 2.86328C4.14453 2.375 3.35156 2.375 2.86328 2.86328C2.375 3.35156 2.375 4.14453 2.86328 4.63281L8.23047 10L2.86719 15.3672C2.37891 15.8555 2.37891 16.6484 2.86719 17.1367C3.35547 17.625 4.14844 17.625 4.63672 17.1367L4.63281 17.1328Z"
                    fill="black"
                  />
                </svg>
              </span>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
